var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageOnboardingWelcome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 288,
    height: 288,
    viewBox: "0 0 288 288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-7 {\n        fill: #fff;\n      }\n\n      .cls-1 {\n        stroke: #16a100;\n        stroke-width: 2px;\n      }\n\n      .cls-2 {\n        fill: #2f2e41;\n      }\n\n      .cls-3 {\n        fill: #a0616a;\n      }\n\n      .cls-4 {\n        fill: #ccc;\n      }\n\n      .cls-5 {\n        fill: #3f3d56;\n      }\n\n      .cls-6 {\n        fill: #b9f6ca;\n      }\n\n      .cls-8 {\n        stroke: none;\n      }\n\n      .cls-9 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "onboarding-welcome",
    transform: "translate(-36 -112)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_488",
    "data-name": "Ellipse 488",
    className: "cls-1",
    transform: "translate(36 112)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 144,
    cy: 144,
    r: 144
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 144,
    cy: 144,
    r: 143
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3542",
    "data-name": "Pfad 3542",
    className: "cls-2",
    d: "M828.443,345.128c2.653,5.217,4.745,10.6,10.6,10.6a10.6,10.6,0,1,0,0-21.194C833.092,334.456,823.5,335.418,828.443,345.128Z",
    transform: "translate(-561.135 -85.342)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3543",
    "data-name": "Pfad 3543",
    className: "cls-3",
    d: "M562.963,498.712l-4.529,1.009-6.048-16.988,6.684-1.49Z",
    transform: "translate(-287.325 -111.481)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3545",
    "data-name": "Pfad 3545",
    className: "cls-3",
    d: "M604.635,514.051h-4.64l-2.208-17.9h6.848Z",
    transform: "translate(-315.543 -120.749)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3547",
    "data-name": "Pfad 3547",
    className: "cls-2",
    d: "M837.956,594.807h-5.922a1.71,1.71,0,0,1-1.687-1.473l-5.368-41.524a.568.568,0,0,0-1.111-.07L820.687,563.6l2.868,27a1.7,1.7,0,0,1-1.309,1.856l-4.7,1.084a1.711,1.711,0,0,1-2.007-1.147l-7.565-26.253a14.8,14.8,0,0,1-.616-5.96l2.367-23.667.18.009,31.6,1.523-1.848,55.117A1.7,1.7,0,0,1,837.956,594.807Z",
    transform: "translate(-548.834 -210.883)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_480",
    "data-name": "Ellipse 480",
    className: "cls-3",
    cx: 9.296,
    cy: 9.296,
    r: 9.296,
    transform: "translate(268.088 251.999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3548",
    "data-name": "Pfad 3548",
    className: "cls-4",
    d: "M841.3,454.29c-.031,0-.061,0-.092,0L809.7,452.594a1.7,1.7,0,0,1-1.53-2.222l2.494-7.743a50.094,50.094,0,0,0,1.323-25.689,16.033,16.033,0,0,1,2.848-12.923,15.8,15.8,0,0,1,11.414-6.3h0q.231-.018.464-.033a15.961,15.961,0,0,1,16.726,18.3l-2.2,14.75,1.751,21.717a1.7,1.7,0,0,1-1.7,1.84Z",
    transform: "translate(-549.333 -124.578)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3549",
    "data-name": "Pfad 3549",
    className: "cls-3",
    d: "M783.558,523.091a3.806,3.806,0,0,0,.594-5.806l6.066-12.088-6.979.826-4.691,11.352a3.826,3.826,0,0,0,5.01,5.715Z",
    transform: "translate(-530.363 -191.419)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3550",
    "data-name": "Pfad 3550",
    className: "cls-3",
    d: "M897.561,526.882a3.806,3.806,0,0,1,.384-5.823l-3.961-12.932,6.743,1.981,2.728,11.976a3.826,3.826,0,0,1-5.894,4.8Z",
    transform: "translate(-602.72 -193.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3551",
    "data-name": "Pfad 3551",
    className: "cls-4",
    d: "M885.192,456.672a1.694,1.694,0,0,1-1.686-1.479l-3.152-23.777-5.028-18.58a5.37,5.37,0,0,1,5.051-6.77h0a5.391,5.391,0,0,1,5.425,4.464l7.492,43.881a1.7,1.7,0,0,1-1.607,1.988l-6.421.271Z",
    transform: "translate(-591.008 -129.805)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3552",
    "data-name": "Pfad 3552",
    className: "cls-4",
    d: "M789.192,451.912a1.739,1.739,0,0,1-.362-.038l-6.285-1.34a1.7,1.7,0,0,1-1.252-2.229l14.719-42.012a5.4,5.4,0,0,1,6.095-3.5h0a5.37,5.37,0,0,1,3.849,7.52l-8.071,17.5-7.072,22.893A1.693,1.693,0,0,1,789.192,451.912Z",
    transform: "translate(-532.62 -127.714)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3553",
    "data-name": "Pfad 3553",
    className: "cls-2",
    d: "M831.247,344.465a12.644,12.644,0,0,0,7.225,2.233,7.751,7.751,0,0,1-3.071,1.263,25.492,25.492,0,0,0,10.413.059,6.741,6.741,0,0,0,2.18-.749,2.759,2.759,0,0,0,1.345-1.8c.228-1.305-.789-2.491-1.845-3.29a13.613,13.613,0,0,0-11.439-2.286,6.265,6.265,0,0,0-3.388,1.915,3.086,3.086,0,0,0-.285,3.665Z",
    transform: "translate(-563.727 -88.425)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3554",
    "data-name": "Pfad 3554",
    className: "cls-5",
    d: "M435.378,171.875H275.664a3.3,3.3,0,0,0-3.3,3.3V330.847a3.3,3.3,0,0,0,3.3,3.3h14V333.2h-14a2.361,2.361,0,0,1-2.358-2.358V175.175a2.361,2.361,0,0,1,2.358-2.358H435.378a2.362,2.362,0,0,1,2.362,2.358V330.847a2.338,2.338,0,0,1-.39,1.294,2.439,2.439,0,0,1-.893.8,2.341,2.341,0,0,1-1.079.261h-14v.942h14a3.3,3.3,0,0,0,2.509-1.158.738.738,0,0,0,.072-.091,3.085,3.085,0,0,0,.473-.8,3.218,3.218,0,0,0,.25-1.253V175.175A3.3,3.3,0,0,0,435.378,171.875Z",
    transform: "translate(-216.364 15.752)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1726",
    "data-name": "Rechteck 1726",
    className: "cls-5",
    width: 165.374,
    height: 0.943,
    transform: "translate(56.47 200.855)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_481",
    "data-name": "Ellipse 481",
    className: "cls-5",
    cx: 2.83,
    cy: 2.83,
    r: 2.83,
    transform: "translate(61.659 191.874)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_482",
    "data-name": "Ellipse 482",
    className: "cls-5",
    cx: 2.83,
    cy: 2.83,
    r: 2.83,
    transform: "translate(69.796 191.874)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_483",
    "data-name": "Ellipse 483",
    className: "cls-5",
    cx: 2.83,
    cy: 2.83,
    r: 2.83,
    transform: "translate(77.934 191.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3555",
    "data-name": "Pfad 3555",
    className: "cls-5",
    d: "M458.366,248.371H378.509a4.92,4.92,0,0,1,0-9.84h79.857a4.92,4.92,0,0,1,0,9.84Zm-79.857-9.083a4.163,4.163,0,1,0,0,8.326h79.857a4.163,4.163,0,1,0,0-8.326Z",
    transform: "translate(-279.278 -25.677)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3556",
    "data-name": "Pfad 3556",
    className: "cls-5",
    d: "M442.876,361.6H322.523a6.441,6.441,0,0,1-6.434-6.434v-38.6a6.441,6.441,0,0,1,6.434-6.434H442.876a6.441,6.441,0,0,1,6.434,6.434v38.6A6.441,6.441,0,0,1,442.876,361.6ZM322.523,310.882a5.683,5.683,0,0,0-5.677,5.677v38.6a5.684,5.684,0,0,0,5.677,5.677H442.876a5.684,5.684,0,0,0,5.677-5.677v-38.6a5.684,5.684,0,0,0-5.677-5.677Z",
    transform: "translate(-243.541 -70.175)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3557",
    "data-name": "Pfad 3557",
    className: "cls-6",
    d: "M459.827,362.681h-42.01a3.028,3.028,0,0,1,0-6.056h42.01a3.028,3.028,0,0,1,0,6.056Z",
    transform: "translate(-304.886 -99.076)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3558",
    "data-name": "Pfad 3558",
    className: "cls-6",
    d: "M498.809,389.681H417.817a3.028,3.028,0,0,1,0-6.056h80.992a3.028,3.028,0,1,1,0,6.056Z",
    transform: "translate(-304.886 -115.857)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_484",
    "data-name": "Ellipse 484",
    className: "cls-6",
    cx: 11.354,
    cy: 11.354,
    r: 11.354,
    transform: "translate(81.367 254.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3559",
    "data-name": "Pfad 3559",
    className: "cls-7",
    d: "M614.4,422.181h-10.6a3.028,3.028,0,1,1,0-6.056h10.6a3.028,3.028,0,1,1,0,6.056Z",
    transform: "translate(-420.483 -136.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3560",
    "data-name": "Pfad 3560",
    className: "cls-4",
    d: "M614.4,422.181h-10.6a3.028,3.028,0,1,1,0-6.056h10.6a3.028,3.028,0,1,1,0,6.056Z",
    transform: "translate(-420.483 -136.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3561",
    "data-name": "Pfad 3561",
    className: "cls-5",
    d: "M442.871,494.125H322.518a6.443,6.443,0,0,0-6.434,6.434v38.6a6.443,6.443,0,0,0,6.434,6.434H442.871a6.44,6.44,0,0,0,6.434-6.434v-38.6a6.441,6.441,0,0,0-6.434-6.434Zm5.677,45.038a5.682,5.682,0,0,1-5.677,5.677H322.518a5.684,5.684,0,0,1-5.677-5.677v-38.6a5.684,5.684,0,0,1,5.677-5.677H442.871a5.682,5.682,0,0,1,5.677,5.677Z",
    transform: "translate(-243.537 -184.537)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3562",
    "data-name": "Pfad 3562",
    className: "cls-6",
    d: "M459.827,546.681h-42.01a3.028,3.028,0,0,1,0-6.056h42.01a3.028,3.028,0,0,1,0,6.056Z",
    transform: "translate(-304.886 -213.438)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3563",
    "data-name": "Pfad 3563",
    className: "cls-6",
    d: "M498.809,573.681H417.817a3.028,3.028,0,0,1,0-6.056h80.992a3.028,3.028,0,0,1,0,6.056Z",
    transform: "translate(-304.886 -230.219)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_485",
    "data-name": "Ellipse 485",
    className: "cls-6",
    cx: 11.354,
    cy: 11.354,
    r: 11.354,
    transform: "translate(81.367 323.97)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3564",
    "data-name": "Pfad 3564",
    className: "cls-4",
    d: "M614.4,606.18h-10.6a3.028,3.028,0,1,1,0-6.055h10.6a3.028,3.028,0,1,1,0,6.055Z",
    transform: "translate(-420.483 -250.419)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3576",
    "data-name": "Pfad 3576",
    className: "cls-2",
    d: "M834.053,700.555l-14.6,3.254-.041-.185a5.823,5.823,0,0,1,4.417-6.951h0l8.919-1.987Z",
    transform: "translate(-556.282 -309.192)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3577",
    "data-name": "Pfad 3577",
    className: "cls-2",
    d: "M866.8,717.327H851.839v-.189a5.823,5.823,0,0,1,5.823-5.823H866.8Z",
    transform: "translate(-576.526 -319.527)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3578",
    "data-name": "Pfad 3578",
    className: "cls-5",
    d: "M839,726.882H786.014a.379.379,0,1,1,0-.757H839a.379.379,0,0,1,0,.757Z",
    transform: "translate(-535.378 -328.732)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageOnboardingWelcome);
export default __webpack_public_path__ + "static/media/image-onboarding-welcome.edf911afe3179a931078a957662b3052.svg";
export { ForwardRef as ReactComponent };